<div class="menu">
	<div class="menu-header">
		<a class="menu-header--link" routerLink="me/information"
			 [defTrackEvent]="{ category: gaCategory, action: 'Navigate to Profil' }">
			<def-side-tabs class="side" [active]="currentUrl==='information'"
										 title="{{ 'ME.SIDEMENU.INFORMATION' | translate }}" selectedTab="information" icon="me">
			</def-side-tabs>
		</a>
		<a class="menu-header--link" routerLink="me/formation"
			 [defTrackEvent]="{ category: gaCategory, action:'Navigate to My Course Instances' }">
			<def-side-tabs class="side" [active]="currentUrl==='formation'"
										 title="{{ 'ME.SIDEMENU.FORMATION' | translate }}" selectedTab="formation" icon="school">
			</def-side-tabs>
		</a>
		<a class="menu-header--link" routerLink="me/reservation"
			 [defTrackEvent]="{ category: gaCategory, action:'Navigate to My Room Bookings' }"
			 *nbIsGranted="['view', 'booking']">
			<def-side-tabs class="side" [active]="currentUrl==='reservation'"
										 title="{{ 'ME.SIDEMENU.RESERVATION' | translate }}" selectedTab="reservation" icon="store">
			</def-side-tabs>
		</a>
		<a class="menu-header--link"
			 href="javascript:Didomi.preferences.show()"
			 [defTrackEvent]="{ category: gaCategory, action:'Manage cookies' }">
			<def-side-tabs class="side" title="{{ 'ME.SIDEMENU.COOKIES' | translate }}" icon="settings">
			</def-side-tabs>
		</a>
	</div>
	<a class="menu-link" (click)="logout()"
		 [defTrackEvent]="{ category: gaCategory, action:'Log out' }">
		<def-side-tabs class="side menu-footer" [active]="currentUrl==='login'"
									 title="{{ 'ME.SIDEMENU.DECONNEXION' | translate }}" selectedTab="deconnexion" icon="close">
		</def-side-tabs>
	</a>
</div>
